export default __webpack_public_path__ + "static/media/Luterek.bd21f93c.png";